import { callbacks, setCallback } from './callbacks';
import { app } from './appEnvironment';
import utils from '../scripts/utils';

const showScannerCodeReader = (finishCallback, redirectCallback) => {
    setCallback("afterFinishScannerCodeReader", finishCallback);
    setCallback("afterRedirectFromScannerCodeReader", redirectCallback);
    app.callFunction("showScannerCodeReader");
}

const didFinishScannerCodeReader = (data) => {
    data = utils.fromStringToJson(data);
    callbacks.afterFinishScannerCodeReader(data);
}

const willRedirectFromScannerCodeReader = () => {
    callbacks.afterRedirectFromScannerCodeReader();
}

const initScanner = () => {
    window.didFinishScannerCodeReader = didFinishScannerCodeReader;
    window.willRedirectFromScannerCodeReader = willRedirectFromScannerCodeReader;
}

export { showScannerCodeReader, initScanner };